import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Competence } from 'src/app/domain/competence';
import { Strategy } from 'src/app/domain/GS/strategy';
import { StrategyService } from 'src/app/services/strategy.service';

@Component({
    selector: 'next-strategy-box',
    templateUrl: 'next-strategy-box.html',
    styleUrls: ['./next-strategy-box.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NextStrategyDialog implements OnInit {

    MasterCompetenceList: Competence[] = []
    StrategyList: Strategy[] = [];

    constructor(
        private snackbar: MatSnackBar,
        private strategyService: StrategyService,
        public dialogRef: MatDialogRef<NextStrategyDialog>,
        @Inject(MAT_DIALOG_DATA) public data: string) {
        if (data) {
            this.getNextStrategies(data)
        }
    }

    ngOnInit() {

    }

    getNextStrategies(agencyCode: string) {
        this.strategyService.getUpcomingAvantTravaux(agencyCode).subscribe(x => {
            this.StrategyList = x;
        })
    }

    onCancel() {
        this.dialogRef.close();
    }

    finish() {
        this.dialogRef.close()
    }
}
